import Link from "next/link"
import logo from "../../../public/images/logo/logo.svg"
import FooterLinkList from "./FooterLinkList"
import { companiesLink, bettingTools, bettingAids } from "./linksData"
import { Locale } from "../../../i18n-config"
import PwaInstallSection from "./PwaInstallSection"
import FeaturedOn from "./FeaturedOn"


const Footer = ({ lang, dictionary }: { lang: Locale; dictionary: any }) => {
  return (
    <>
      <footer className="relative z-10 pb-17.5 lg:pb-22.5 xl:pb-27.5 lg:px-3 px-0">
        {/* <!-- bg shapes --> */}
        <div className="absolute bottom-0 left-0 w-full flex flex-col gap-3 -z-1 opacity-50">
          <div className="w-full h-[1.24px] footer-bg-gradient"></div>
          <div className="w-full h-[2.47px] footer-bg-gradient"></div>
          <div className="w-full h-[3.71px] footer-bg-gradient"></div>
          <div className="w-full h-[4.99px] footer-bg-gradient"></div>
          <div className="w-full h-[6.19px] footer-bg-gradient"></div>
          <div className="w-full h-[7.42px] footer-bg-gradient"></div>
          <div className="w-full h-[8.66px] footer-bg-gradient"></div>
          <div className="w-full h-[9.90px] footer-bg-gradient"></div>
          <div className="w-full h-[13px] footer-bg-gradient"></div>
        </div>

        <div className="max-w-[1170px] mx-auto px-4 sm:px-8 xl:px-0 relative pt-17.5">
          <div className="w-full h-[1px] footer-divider-gradient absolute top-0 left-0"></div>

          <div className="flex flex-wrap justify-between">
            <div className="mb-10 max-w-[520px] w-full">
              <Link href={`/${lang}`} className="mb-8.5 inline-block">
                <img
                  src={logo.src}
                  alt="Logo"
                  width={195}
                  height={54}
                  className="block h-auto w-[185px] max-w-none sm:w-[195px]"
                />
              </Link>

              <p className="mb-12 xl:w-4/5">
              {dictionary.page.home.footer["slogan"]}
              </p>

              <div className="flex items-center gap-5">
                {/* <a
                  href="https://www.facebook.com/share/1CDxtGHtTk/?mibextid=wwXIfr"
                  target="_blank" 
                  rel="noopener noreferrer"
                  aria-label="facebook"
                  className="hover:text-white ease-in duration-300"
                >
                  <svg
                    className="fill-current"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13 21.9506C18.0533 21.4489 22 17.1853 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 16.8379 5.43552 20.8734 10 21.8V16H7V13H10V9.79586C10 7.47449 11.9695 5.64064 14.285 5.80603L17 5.99996V8.99996H15C13.8954 8.99996 13 9.89539 13 11V13H17L16 16H13V21.9506Z"
                      fill=""
                    />
                  </svg>
                </a> */}

                <a
                  href="https://t.me/OFalert1_bot"
                  target="_blank" 
                  rel="noopener noreferrer"
                  aria-label="telegram"
                  className="hover:text-white ease-in duration-300"
                >
                  <svg
                    className="fill-current"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9.04 15.41l-.39 5.48c.56 0 .8-.24 1.09-.53l2.62-2.51 5.43 3.96c.99.55 1.7.26 1.95-.91l3.54-16.6.01-.02c.31-1.44-.52-2-1.49-1.65L1.43 9.59c-1.42.55-1.4 1.33-.24 1.69l5.39 1.68 12.53-7.85c.59-.36 1.13-.16.69.23"
                      fill="currentColor"
                    />
                  </svg>
                </a>

                <a
                  href="https://wa.me/18194104160"
                  target="_blank" 
                  rel="noopener noreferrer"
                  aria-label="whatsapp"
                  className="hover:text-white ease-in duration-300"
                >
                  <svg
                    className="fill-current"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M20.52 3.48A11.92 11.92 0 0 0 12.01 0C5.37 0 .02 5.35.02 12c0 2.11.55 4.17 1.59 6.01L0 24l6.18-1.61A11.94 11.94 0 0 0 12 24c6.63 0 12-5.37 12-12 0-3.19-1.24-6.19-3.48-8.52zM12 21.82a9.8 9.8 0 0 1-5-1.37l-.36-.21-3.67.96.98-3.58-.23-.37A9.81 9.81 0 0 1 2.18 12c0-5.41 4.4-9.82 9.82-9.82 2.62 0 5.08 1.02 6.93 2.87a9.76 9.76 0 0 1 2.87 6.93c0 5.42-4.41 9.82-9.82 9.82zm5.44-7.36c-.3-.15-1.77-.87-2.05-.97-.28-.1-.48-.15-.68.15-.2.29-.78.96-.96 1.15-.17.19-.35.21-.65.07-1.78-.89-2.94-1.57-4.1-3.55-.31-.53.33-.49.9-1.63.1-.19.05-.36-.02-.5-.07-.14-.69-1.65-.95-2.25-.25-.59-.5-.51-.69-.52h-.59c-.2 0-.52.07-.8.37-.28.3-1.07 1.05-1.07 2.57s1.1 3 1.26 3.21c.15.2 2.18 3.33 5.27 4.67.73.32 1.29.5 1.72.64.72.23 1.35.19 1.85.12.56-.08 1.79-.73 2.04-1.43.25-.7.25-1.3.18-1.44-.07-.14-.28-.22-.59-.37z"
                      fill="currentColor"
                    />
                  </svg>
                </a>

                {/* <a
                  href="https://www.instagram.com/odds.fantasy"
                  target="_blank" 
                  rel="noopener noreferrer"
                  aria-label="instagram"
                  className="hover:text-white ease-in duration-300"
                >
                  <svg
                    className="fill-current"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7 2C4.24 2 2 4.24 2 7v10c0 2.76 2.24 5 5 5h10c2.76 0 5-2.24 5-5V7c0-2.76-2.24-5-5-5H7zm10 2c1.65 0 3 1.35 3 3v10c0 1.65-1.35 3-3 3H7c-1.65 0-3-1.35-3-3V7c0-1.65 1.35-3 3-3h10zM12 7a5 5 0 100 10 5 5 0 000-10zm0 2a3 3 0 110 6 3 3 0 010-6zm5.5-3a1.5 1.5 0 11-3.001.001A1.5 1.5 0 0117.5 6z"
                      fill="currentColor"
                    />
                  </svg>
                </a> */}

                {/* <a
                  href="https://x.com/oddsfantasy?s=21"
                  target="_blank" 
                  rel="noopener noreferrer"
                  aria-label="X"
                  className="hover:text-white ease-in duration-300"
                >
                  <svg
                    className="fill-current"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7.6125 21.5251C16.4625 21.5251 21.2625 14.2126 21.2625 7.87509C21.2625 7.72509 21.2625 7.46259 21.225 7.23759C22.1625 6.56259 22.9875 5.70009 23.625 4.76259C22.725 5.17509 21.825 5.40009 20.8875 5.51259C21.9 4.91259 22.65 3.97509 22.9875 2.8501C22.05 3.3751 21.075 3.78759 19.9125 4.01259C19.0125 3.0751 17.8125 2.4751 16.425 2.4751C13.7625 2.4751 11.5875 4.65009 11.5875 7.31259C11.5875 7.68759 11.625 8.06259 11.7 8.43759C7.8375 8.17509 4.3125 6.26259 1.9125 3.3751C1.5 4.12509 1.275 4.91259 1.275 5.77509C1.275 7.46259 2.1375 8.88759 3.45 9.75009C2.6625 9.71259 1.9125 9.48759 1.275 9.15009C1.275 9.18759 1.275 9.18759 1.275 9.18759C1.275 11.4751 2.925 13.4626 5.1 13.9126C4.6875 14.0251 4.2375 14.0626 3.9 14.0626C3.6 14.0626 3.2625 14.0251 3 13.9501C3.6375 15.8626 5.4 17.2501 7.5 17.2876C5.85 18.5626 3.7875 19.3501 1.575 19.3501C1.125 19.4251 0.75 19.3501 0.375 19.3126C2.4 20.7376 4.9125 21.5251 7.6125 21.5251Z"
                      fill=""
                    />
                  </svg>
                </a> */}

                {/* <a
                  href="https://www.tiktok.com/@oddsfantasy.sport"
                  target="_blank" 
                  rel="noopener noreferrer"
                  aria-label="tiktok"
                  className="hover:text-white ease-in duration-300"
                >
                  <svg
                    className="fill-current"
                    width="24"
                    height="24"
                    viewBox="0 0 256 256"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M216.19 85.94a75.51 75.51 0 01-45.21-14.79V164a56 56 0 11-48-55.68v32.15a24 24 0 1016 22.53V24h32a43.6 43.6 0 003.54 17.19 43.91 43.91 0 0012.34 16 43.58 43.58 0 0027.33 9.81Z"
                      fill="currentColor"
                    />
                  </svg>
                </a> */}

                <a
                  href="https://www.youtube.com/@oddsfantasy"
                  target="_blank" 
                  rel="noopener noreferrer"
                  aria-label="youtube"
                  className="hover:text-white ease-in duration-300"
                >
                  <svg
                    className="fill-current"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill="currentColor"
                      d="M23.498 6.186a2.974 2.974 0 0 0-2.09-2.103C19.5 3.5 12 3.5 12 3.5s-7.5 0-9.408.583a2.974 2.974 0 0 0-2.09 2.103C0 8.09 0 12 0 12s0 3.91.502 5.814a2.974 2.974 0 0 0 2.09 2.103C4.5 20.5 12 20.5 12 20.5s7.5 0 9.408-.583a2.974 2.974 0 0 0 2.09-2.103C24 15.91 24 12 24 12s0-3.91-.502-5.814ZM9.75 15.568V8.432L15.818 12 9.75 15.568Z"
                    />
                  </svg>
                </a>

              </div>

              <p className="font-medium mt-5.5">
              {dictionary.page.home.footer["rights"]}
              </p>
            </div>

            <div className="w-full max-w-none">
              <div className="grid grid-cols-2 gap-x-6 gap-y-10 md:grid-cols-4 md:gap-x-8">
                <FooterLinkList title={dictionary.page.home.footer["betting_tools"]} links={bettingTools(dictionary)} lang={lang}/>

                <FooterLinkList title={dictionary.page.home.footer["betting_aids"]} links={bettingAids(dictionary)} lang={lang}/>

                <FooterLinkList title={dictionary.page.home.footer["company"]} links={companiesLink(dictionary)} lang={lang}/>

                <PwaInstallSection
                  copy={{
                    mobile_app: dictionary.page.home.footer["mobile_app"],
                    install_app: dictionary.page.home.footer["install_app"],
                    installing_app:
                      dictionary.page.home.footer["installing_app"],
                    app_installed:
                      dictionary.page.home.footer["app_installed"],
                    install_unavailable:
                      dictionary.page.home.footer["install_unavailable"],
                    install_manual_title:
                      dictionary.page.home.footer["install_manual_title"],
                    install_manual_subtitle:
                      dictionary.page.home.footer["install_manual_subtitle"],
                    install_manual_close:
                      dictionary.page.home.footer["install_manual_close"],
                    install_generic_instructions:
                      dictionary.page.home.footer["install_generic_instructions"],
                    install_android_instructions:
                      dictionary.page.home.footer["install_android_instructions"],
                    install_chrome_desktop_instructions:
                      dictionary.page.home.footer[
                        "install_chrome_desktop_instructions"
                      ],
                    install_ios_instructions:
                      dictionary.page.home.footer["install_ios_instructions"],
                    install_ios_other_browser_instructions:
                      dictionary.page.home.footer[
                        "install_ios_other_browser_instructions"
                      ],
                    install_mac_instructions:
                      dictionary.page.home.footer["install_mac_instructions"],
                  }}
                />
              </div>
            </div>
          </div>
          <FeaturedOn title={dictionary.page.home.footer["featured_on"]} />
          <div>
            <br/>
              <p>
                {dictionary.page.home.footer["disclaimer"]}
              </p>
            </div>
        </div>
      </footer>
    </>
  )
}

export default Footer
